export default "__VITE_ASSET__BoRvMAUY__"